(function (globalScope) {
  'use strict';

  const WISHLIST_KEY = 'items';

  function normalizeWishlistItems(raw) {
    let values = raw;
    if (typeof raw === 'string') {
      try { values = JSON.parse(raw); }
      catch (error) { values = []; }
    }
    if (!Array.isArray(values)) return [];
    return Array.from(new Set(values
      .filter((value) => typeof value === 'string')
      .map((value) => value.trim())
      .filter(Boolean)));
  }

  function readWishlistItems(storage) {
    if (!storage || typeof storage.getItem !== 'function') return [];
    return normalizeWishlistItems(storage.getItem(WISHLIST_KEY));
  }

  function writeWishlistItems(storage, handles) {
    const normalized = normalizeWishlistItems(handles);
    if (storage && typeof storage.setItem === 'function') {
      storage.setItem(WISHLIST_KEY, JSON.stringify(normalized));
    }
    return normalized;
  }

  function updateWishlistUI(handles) {
    if (typeof document === 'undefined') return;
    document.querySelectorAll('.wishCount').forEach((node) => {
      node.textContent = String(handles.length);
    });
    document.querySelectorAll('[data-icon-wishlist][data-product-handle]').forEach((node) => {
      const selected = handles.includes(String(node.dataset.productHandle || '').trim());
      node.classList.toggle('whislist-added', selected);
      node.setAttribute('aria-pressed', String(selected));
    });
  }

  function emitWishlistUpdated(storage) {
    const handles = readWishlistItems(storage);
    updateWishlistUI(handles);
    if (typeof document !== 'undefined') {
      document.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { handles, count: handles.length }
      }));
    }
    return handles;
  }

  const api = {
    key: WISHLIST_KEY,
    normalize: normalizeWishlistItems,
    read: function () { return readWishlistItems(globalScope.localStorage); },
    write: function (handles) {
      const result = writeWishlistItems(globalScope.localStorage, handles);
      emitWishlistUpdated(globalScope.localStorage);
      return result;
    },
    emit: function () { return emitWishlistUpdated(globalScope.localStorage); }
  };

  globalScope.ChicSewWishlist = api;

  if (typeof document !== 'undefined' && !document.documentElement.dataset.wishlistShowroomSync) {
    document.documentElement.dataset.wishlistShowroomSync = 'true';
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-icon-wishlist]')) return;
      globalScope.setTimeout(function () { emitWishlistUpdated(globalScope.localStorage); }, 0);
    });
    globalScope.addEventListener('storage', function (event) {
      if (event.key === WISHLIST_KEY) emitWishlistUpdated(globalScope.localStorage);
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      WISHLIST_KEY,
      normalizeWishlistItems,
      readWishlistItems,
      writeWishlistItems
    };
  }
})(typeof window !== 'undefined' ? window : globalThis);
